import SubmissionNavigationDropdown from 'components/Grading/SubmissionNavigationDropdown';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Grading/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Skeleton, Stack, styled, Text } from 'shell/components';

const Header = () => {
    const { t } = useTranslation();
    const { device } = useViewport();

    const {
        submissions,
        headerNavigationOptions,
        currentSubmission,
        hasChanges,
        selectedFileId,
        sort,
        setSort,
        isGradesGenerating,
        isFeedbackGenerating,
        handleClickNext,
        handleSelectSubmission,
    } = useContext(PageContext);

    const isGenerating = isGradesGenerating || isFeedbackGenerating;
    const currentFile = currentSubmission.files.find(({ id }) => id === selectedFileId);
    const currentFileTitle = currentSubmission.api
        ? (currentSubmission.api.user.name ?? currentSubmission.api.user.id)
        : currentFile?.original_file
          ? currentFile?.original_file.name
          : currentFile?.name;

    const SubmissionTitle = currentFile ? (
        <Text component={'h1'} noWrap title={currentFileTitle} variant={'p1'}>
            {currentFileTitle}
        </Text>
    ) : (
        <Skeleton sx={{ fontSize: '1rem' }} width={250} />
    );

    const getSubmissionTimestamp = (dateValue) => (
        <Text color={'light'} variant={'p3'}>
            {t('ui.uploaded', 'Uploaded')}: {t('ui.format-date-short', { val: dateValue })} (
            {t('ui.format-time-only', { val: dateValue })})
        </Text>
    );

    const SkipButton = (
        <Button disabled={isGenerating || submissions.length === 1} variant={'tertiary'} onClick={handleClickNext}>
            {!hasChanges ? t('controls.next', 'Next') : t('controls.skip', 'Skip')}
        </Button>
    );

    const NavigationDropdown = (
        <SubmissionNavigationDropdown
            disabled={isGenerating}
            currentSubmission={currentSubmission}
            options={headerNavigationOptions}
            sort={sort}
            setSort={setSort}
            selectSubmission={handleSelectSubmission}
        />
    );

    return device === 'mobile' ? (
        <RootStack device={device} justifyContent={'space-between'}>
            <Stack spacing={1}>
                {SubmissionTitle}
                {getSubmissionTimestamp(currentSubmission.api?.file?.submitted_on ?? currentSubmission.created_on)}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                {NavigationDropdown}
                {SkipButton}
            </Stack>
        </RootStack>
    ) : (
        <RootStack alignItems={'center'} device={device} direction={'row'} justifyContent={'space-between'} spacing={4}>
            <Stack sx={{ flex: 1, minWidth: 0 }} spacing={1}>
                {SubmissionTitle}
                {getSubmissionTimestamp(currentSubmission.api?.file?.submitted_on ?? currentSubmission.created_on)}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} spacing={4}>
                {NavigationDropdown}
                {SkipButton}
            </Stack>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '109px' : '65px',
        padding: device === 'mobile' ? theme.spacing(3, 4) : theme.spacing(3, 5),
        background: theme.palette.ensightful.primary[50],
    };
});

export default Header;
